export const DEFAULT_TASK_STATUS = {
  label: 'Open',
  value: 'open'
};

export const TASK_STATUSES = [
  DEFAULT_TASK_STATUS,
  {
    label: 'In progress',
    value: 'in progress'
  },
  {
    label: 'Done',
    value: 'done'
  }
];

export const DEFAULT_TASK_PRIORITY = {
  label: 'Medium',
  value: 'medium'
};

export const TASK_PRIORITIES = [
  {
    label: 'Low',
    value: 'low'
  },
  DEFAULT_TASK_PRIORITY,
  {
    label: 'High',
    value: 'high'
  }
];

export const TASK_MODAL_MODE = {
  CREATE: 'create',
  UPDATE: 'update',
  VIEW: 'view'
};
